import { BASE_PATH } from './constants';

/**
 * Helper method for returning a path for an asset in the public directory with the base path
 * @param path path to asset in public directory
 */
export const getAssetPath = (path: string): string => {
  if (path.startsWith('http')) {
    return path;
  }
  return `${BASE_PATH}${path}`;
};
